import { EndOfJourneyScanItem } from '../../lib/types/models/end-of-journey-scan/end-of-journey-scan'
import { API, constructApiUrl } from '../apis.config'
import { uploadFileSecurely, UploadPurpose } from '../media/secure-upload'
import { restApiClient } from '../rest-api-client'

// The failed questionnaire scanned again (a new PDF of this questionnaire only)
export async function reuploadEndOfJourneyScanItem(input: { id: number; file: File }) {
  const uploadId = await uploadFileSecurely({
    file: input.file,
    purpose: UploadPurpose.END_OF_JOURNEY_SCAN
  })
  return restApiClient
    .url(constructApiUrl(API['end-of-journey-scans'].reuploadItem.url, { id: input.id }))
    .post<EndOfJourneyScanItem>({ uploadId })
}
